module.exports = __webpack_public_path__ + "img/contact-icon.16043bf9.png";